import Client from '../clients/clientModel'
import * as moment from 'moment'

export default class Appointment {
  _key: string
  id: string
  appointmentDate: string
  time: string
  status: number
  waitingDate: string
  seatedDate: string
  completedDate: string
  checkedOutDate: string
  client: Client
  appointmentType: number
  missedAppt: boolean

  constructor (instance: any) {
    this._key = instance._key
    this.id = instance.id
    this.appointmentDate = instance.appointmentDate.substring(0, instance.appointmentDate.length - 2)
    this.time = instance.appointmentDate.split('T')[1].split(':').filter((_t: any, i: number) => i <= 1).join(':')
    this.status = instance.status
    this.waitingDate = instance.waitingDate
    this.seatedDate = instance.seatedDate
    this.completedDate = instance.completedDate
    this.checkedOutDate = instance.checkedOutDate
    if (instance.client) {
      this.client = new Client(instance.client)
    }
    this.appointmentType = instance.appointmentType

    this.missedAppt = this.status < 20 && moment(this.appointmentDate).add(15, 'minute').diff(moment()) < 0
  }
}
